import translations from '../data/i18n/translations';
import urlparam from 'urlparam';
import _ from 'lodash';

export default _.memoize(function(locale) {
    var translationsMap = {};
    _(translations).each(function(translation) {
        translationsMap[translation.Key] = translation[locale];
    });
    return translationsMap;
});
